module.exports = __webpack_public_path__ + "img/r4.32f368ac.jpg";